/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MatchType = 0 | 1 | 2;

export const MatchType = {
    NUMBER_0: 0 as MatchType,
    NUMBER_1: 1 as MatchType,
    NUMBER_2: 2 as MatchType
};

